module.exports = __webpack_public_path__ + "images/html_emails/images/status_warning.gif";